import { useEffect, useState } from "react";
import Cubit from "../core/utils/cubit";


function useCubit<State>(cubit: Cubit<State>): State {
    const [state, setState] = useState<State>(cubit.state);
    useEffect(() => {

        cubit.stream.subscribe((value: State) => {
            setState(value);
        });

        return () => {
            cubit.dispose();
        }
        
    }, [cubit]);
    return state;
}

export default useCubit;